<template>
  <div class="login buffer-top">
    <b-container>
      
      <b-row align-h="center">
        <b-col md="12">
          <b-alert variant="success" :show="result === 'success'">
                Zur Bestätigung Ihrer Email-Adresse haben wir ihnen eine Aktivierungs-Mail zugesand. Bitte checken Sie Ihr Postfach: <b>{{email}}</b>
          </b-alert>
          <b-alert variant="danger" :show="result === 'failed'">
              <b>Registrieung konnte nicht durchgeführt werden: </b>
              <span v-for="(error, index) in errors" :key="index"><br>{{error}}</span>
          </b-alert>
        </b-col>
        <b-col md="4" v-if="result !== 'success'">
          
          <h2>Registrierung</h2>
          
          <b-form @submit.prevent="onRegister">
            <b-form-group>
              <b-form-input
                id="input-email"
                v-model="email"
                type="text"
                reqired
                placeholder="Benutzername"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input
                id="input-password"
                v-model="password"
                type="password"
                reqired
                placeholder="Passwort"
              ></b-form-input>
            </b-form-group>
            <div class="text-right">
              <b-button type="submit" variant="primary">Registrieren</b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Auth from '../misc/Auth.js';

export default {
  name: 'Register',
  data: function () {
    return {
      email: '',
      password: '',
      errors: null,
      result: null,
    }
  },

  props: {
    redirect: String
  },

  methods: {
    onRegister: function () {
      Auth.register(this.email, this.password)
        .then((response) => {
          this.result = 'success';
          this.password = '';
        })
        .catch(e => {
          this.result = 'failed';
          if(e.response && e.response.data && Array.isArray(e.response.data)) {
            this.errors = e.response.data.map(err => err.message)
          } 
          else if(e.response && e.response.data) {
            this.errors = [e.response.data.message]
          } else {
            this.errors = ['Unknown error occured']
          }

          this.password = '';
        })
    }
  }
}

</script>
